import { DataResponse } from '../responses/baseResponse';
import { HttpClient } from '../httpClient';
import QuickbooksBillRequest from '../requests/quickbooksBillRequest';
import QuickbooksExportRequest from '../requests/quickbooksExportRequest';
import StringResponse from '../responses/stringResponse';
import User from '../models/user';
import BillExportModel from '../models/billExportModel';

const httpClient = new HttpClient();

export const searchBillCreate = async (
  quickbooksBillRequest: QuickbooksBillRequest
) => {
  return httpClient.post<DataResponse<User[]>>({
    url: '/v1/Quickbooks/SearchBillCreate',
    payload: quickbooksBillRequest,
    requiresToken: true,
  });
};
export const billsExported = async () => {
  return httpClient.get({
    url: '/v1/Quickbooks/BillsExported',
    requiresToken: true,
  });
};

export const billExportedById = async (userId: number) => {
  return httpClient.get({
    url: `/v1/Quickbooks/BillExportedById/${userId}`,
    requiresToken: true,
  });
};

export const deleteBillExport = async (billExportId: number) => {
  return httpClient.delete({
    url: `/v1/Quickbooks/${billExportId}`,
    requiresToken: true,
  });
};

export const billExport = async (
  quickbooksExportRequest: QuickbooksExportRequest
) => {
  return httpClient.post({
    url: '/v1/Quickbooks/BillExport',
    payload: quickbooksExportRequest,
    requiresToken: true,
  });
};

export const downloadBills = async (billExportId: number) => {
  return httpClient.get<StringResponse>({
    url: `/v1/Quickbooks/Download/?billExportId=${billExportId}`,
    requiresToken: true,
  });
};

export const downloadBillsDebug = async (billExportId: number) => {
  return httpClient.get<DataResponse<BillExportModel[]>>({
    url: `/v1/Quickbooks/Download/Debug/?billExportId=${billExportId}`,
    requiresToken: true,
  });
};

export const sendBills = async (req: any) => {
  return httpClient.post({
    url: '/v1/Quickbooks/SendBills',
    payload: req,
    requiresToken: true,
  });
};